module.exports = __webpack_public_path__ + "static/daring-greatly-0e3d947cee1a651b84e552aa18bd2815.jpg";